'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  client: null,
  clientTs: null,
  metadata: null,
  senderId: null,
  senderType: null,
  status: null,
  timestamp: null
}, 'PubNubMessageRecord');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/records/PubNubMessageRecord.js
// module id = 162
// module chunks = 0 1